module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_6_EMPRENDIMIENTO.9d3cb39b.jpg";